module.exports = __webpack_public_path__ + "img/energy-efficiency.f4d5aea0.webp";